import React from 'react';
import './Button.css';

/**
 * Button
 * A reusable button with variant, size, loading state, and icon support.
 *
 * @param {object}          props
 * @param {'primary'|'ghost'|'outline'} [props.variant='primary']
 * @param {'sm'|'md'|'lg'}  [props.size='md']
 * @param {boolean}         [props.isLoading=false]
 * @param {boolean}         [props.disabled=false]
 * @param {string}          [props.type='button']
 * @param {React.ReactNode} [props.iconLeft]
 * @param {React.ReactNode} [props.iconRight]
 * @param {Function}        [props.onClick]
 * @param {string}          [props.className]
 * @param {React.ReactNode} props.children
 */
export default function Button({
  variant = 'primary',
  size = 'md',
  isLoading = false,
  disabled = false,
  type = 'button',
  iconLeft,
  iconRight,
  onClick,
  className = '',
  children,
  ...rest
}) {
  const isDisabled = disabled || isLoading;

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={isDisabled}
      aria-disabled={isDisabled}
      className={[
        'btn',
        `btn--${variant}`,
        `btn--${size}`,
        isLoading ? 'btn--loading' : '',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      {...rest}
    >
      {isLoading && <span className="btn__spinner" aria-hidden="true" />}
      {!isLoading && iconLeft && (
        <span className="btn__icon btn__icon--left" aria-hidden="true">
          {iconLeft}
        </span>
      )}
      <span className="btn__label">{children}</span>
      {!isLoading && iconRight && (
        <span className="btn__icon btn__icon--right" aria-hidden="true">
          {iconRight}
        </span>
      )}
    </button>
  );
}
